var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4213 26.2017C25.4213 25.89 25.2974 25.5911 25.077 25.3706C24.8565 25.1502 24.5576 25.0263 24.2459 25.0263H4.49133C4.17959 25.0263 3.88072 25.1502 3.66026 25.3706C3.4398 25.5911 3.31592 25.89 3.31592 26.2017V27H25.4213L25.4213 26.2017Z",
    fill: "#A5334F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0791 24.2371H22.6581V15.1581C22.6581 12.9596 21.7848 10.851 20.2302 9.29658C18.6757 7.74194 16.5672 6.86859 14.3686 6.86859C12.17 6.86859 10.0615 7.74194 8.50709 9.29658C6.95245 10.851 6.0791 12.9595 6.0791 15.1581V24.2371Z",
    fill: "#A5334F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42114 4.26331L5.36822 3.31586L7.73695 5.68422L6.78987 6.63167L4.42114 4.26331Z",
    fill: "#A5334F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 5.68422L23.369 3.31586L24.3161 4.26331L21.9473 6.63167L21.0002 5.68422Z",
    fill: "#A5334F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4003 9.84053L28.7499 9.82019L28.7579 11.1598L25.4083 11.1801L25.4003 9.84053Z",
    fill: "#A5334F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.665726 9.84053L4.01529 9.82019L4.02327 11.1598L0.673701 11.1801L0.665726 9.84053Z",
    fill: "#A5334F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7892 4.00069L13.8757 0.652182L15.2149 0.686936L15.1284 4.03545L13.7892 4.00069Z",
    fill: "#A5334F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyIcon);
export default __webpack_public_path__ + "static/media/emergencyIcon.2cc0a37739b55d444b0bb872e9c580b7.svg";
export { ForwardRef as ReactComponent };